const BASE_URL = "/transaction/mandates";

export const PAGE_URLS = {
  home: "/",
  list: BASE_URL,
  details: `${BASE_URL}/:id`,
  getLinkToDetails: (id: string) => `${BASE_URL}/${id}`,
  // notifications: `${BASE_URL}/:id/notifications`,
  // getLinkToNotifications: (id: string) => `${BASE_URL}/${id}/notifications`,
  // payments: `${BASE_URL}/:id/payments`,
  // getLinkToPayments: (id: string) => `${BASE_URL}/${id}/payments`,
} as const;
